<template lang="pug">
  .gl-dashboard
    // nav
    gl-nav(@param-height="bindEmbedPadding")

    // loading
    .gl-dashboard__loading(v-if="dashboard.isLoading" layout="row" layout-align="center center")
      pulse-loader(:loading="true" :color="'#8EA2AC'" :size="'14px'")

    // blank state
    gl-blank-state(:options="blankSettings" v-if="dashboard.is404")
    // iframe
    .gl-dashboard__container(v-if="dashboard.meta && dashboard.meta.url")
      iframe.gl-dashboard__embed(:src="dashboard.meta.url" :style="{ paddingTop: embedPaddingTop }" width="100%" height="100%")
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  // data
  data () {
    return {
      embedPaddingTop: '65px',
      blankSettings: {
        title: 'No dashboards found',
        icon: 'chart-bar',
        description: ''
      }
    }
  },

  // computed
  computed: {
    ...mapGetters(['dashboard'])
  },

  // on mount
  mounted () {
    // if admin or superAdmin -> add description to blankSettings
    this.blankSettings.description = (this.$glAuth.isAdmin() || this.$glAuth.isSuperAdmin()) ? 'Navigate to <a href="/#/settings/groups">Group Settings</a> to add a dashboard for this group.' : ''

    // mode event listener => binds the export csv link
    window.addEventListener('message', function (e) {
      // always check the origin and make sure it is from modeanalytics.com
      if (e.origin === 'https://modeanalytics.com') {
        if (e.data['type'] === 'reportExportPaths') {
          const modeBaseUrl = e.origin
          const csvExportUrl = e.data['report_csv_export_path']
          const csvExportLink = document.getElementById('csv-export-link')
          if (csvExportLink) {
            csvExportLink.href = modeBaseUrl + csvExportUrl
          }
        }
      }
    })
  },

  // methods
  methods: {
    bindEmbedPadding (paramHeight) {
      this.embedPaddingTop = (paramHeight + 64) + 'px'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.gl-dashboard {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  &__container {
    position: relative;
    width: 100%;
    height: 100%;
  }

  &__header {
    border-bottom: 1px solid $gl-grey-border;
    margin-bottom: 14px;
  }

  &__embed {
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    padding-top: 210px;
    right: 0;
    bottom: 0;
    left: 0;
    border: 0;
    overflow: hidden;
  }

  &__loading {
    position: absolute;
    z-index: 1;
    left: 50%;
    margin-left: -60px;
    padding: $gl-gutter;
    height: 40px;
    max-height: 40px;
    overflow: hidden;
    transition: all 0.3s;
    width: 120px;
    top: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue